import { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  TableBody,
  TableContainer,
  TablePagination,
  FormControlLabel
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import RejectRequestModal from '../../common/Modal/RejectRequestModal';
import useTable, { getComparator, emptyRows } from '../../../hooks/useTable';
// components
import Scrollbar from '../../Scrollbar';
import {
  TableEmptyRows,
  TableHeadCustom,
  TableNoData
  // TableSelectedActions
} from '../../../fl-components/table';
// sections
import InviteTableRow from './InviteTableRow';
import InviteTableToolbar from './InviteTableToolbar';
import { getCke } from '../../../helper/cookieHelper';
import { updateInviteRequest } from '../../../service/invite.service';
import { REMOVE_REQUEST } from '../../../redux/pendingRequest.reducer';

const TABLE_HEAD = [
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'mobileNumber', label: 'Mobile number', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function InviteTable({ list, filterOption }) {
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    //
    selected,
    onSelectRow,
    // onSelectAllRows,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage
  } = useTable();

  const [filterName, setFilterName] = useState('');

  const [filterClass, setFilterClassId] = useState('all');
  // Reject modal state
  const [isModalOpen, setOpenModal] = useState(false);
  // Reject modal button loading state
  const [modalBtnLoading, setModalBtnLoading] = useState(false);
  // Reject request note
  const [note, setNote] = useState('');
  // Selected id
  const [selectedId, setSelectedId] = useState('');
  // Notification
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleFilterName = (filterName) => {
    setFilterName(filterName);
    setPage(0);
  };

  const handleFilterClass = (value) => {
    setFilterClassId(value);
  };

  const handleReject = async () => {
    setModalBtnLoading(true);
    const obj = {
      approverUserId: getCke('userId'),
      requesterStatus: 'rejected'
    };
    if (note.trim() !== '') obj.approverNotes = note;
    const res = await updateInviteRequest(selectedId, obj);
    if (res) {
      if (res?.statusCode && res?.statusCode !== 200)
        enqueueSnackbar('Please try again later', {
          variant: 'error'
        });
      else {
        setSelectedId('');
        setNote('');
        dispatch({ type: REMOVE_REQUEST, payload: selectedId });
        setOpenModal(false);
        enqueueSnackbar('Request Rejected', {
          variant: 'success'
        });
      }
    }
    setModalBtnLoading(false);
  };

  const handleDeleteRow = (id) => {
    setOpenModal(true);
    setSelectedId(id);
  };

  // const handleDeleteRows = (selected) => {
  //   const deleteRows = tableData.filter((row) => !selected.includes(row.id));
  //   setSelected([]);
  //   setTableData(deleteRows);
  // };

  // const handleEditRow = (id) => {
  //   // navigate(PATH_DASHBOARD.user.edit(paramCase(id)));
  // };

  const dataFiltered = applySortFilter({
    tableData: list,
    comparator: getComparator(order, orderBy),
    filterName,
    filterClass
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound =
    (!dataFiltered.length && !!filterName) || (!dataFiltered.length && !!filterClass);

  return (
    <Card>
      <InviteTableToolbar
        onFilterName={handleFilterName}
        optionsClass={filterOption}
        onFilterClass={handleFilterClass}
      />

      <Scrollbar>
        <TableContainer sx={{ minWidth: 800, position: 'relative' }}>
          {/* {selected.length > 0 && (
            <TableSelectedActions
              dense={dense}
              numSelected={selected.length}
              rowCount={tableData.length}
              onSelectAllRows={(checked) =>
                onSelectAllRows(
                  checked,
                  tableData.map((row) => row.id)
                )
              }
              actions={
                <Tooltip title="Delete">
                  <IconButton color="primary" onClick={() => handleDeleteRows(selected)}>
                    <Iconify icon="eva:trash-2-outline" />
                  </IconButton>
                </Tooltip>
              }
            />
          )} */}

          <Table size={dense ? 'small' : 'medium'}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataFiltered.length}
              numSelected={selected.length}
              onSort={onSort}
              // onSelectAllRows={(checked) =>
              //   onSelectAllRows(
              //     checked,
              //     tableData.map((row) => row.id)
              //   )
              // }
            />

            <TableBody>
              {dataFiltered
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <InviteTableRow
                    key={row.id}
                    row={row}
                    selected={selected.includes(row.id)}
                    onSelectRow={() => onSelectRow(row.id)}
                    onDeleteRow={() => handleDeleteRow(row.id)}
                  />
                ))}

              <TableEmptyRows
                height={denseHeight}
                emptyRows={emptyRows(page, rowsPerPage, dataFiltered.length)}
              />

              <TableNoData isNotFound={isNotFound} />
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <Box sx={{ position: 'relative' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={dataFiltered.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />

        <FormControlLabel
          control={<Switch checked={dense} onChange={onChangeDense} />}
          label="Dense"
          sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
        />
      </Box>

      {/* When reject request then we double check to delete request */}
      <RejectRequestModal
        open={isModalOpen}
        onClose={() => {
          setOpenModal(false);
          setSelectedId('');
          setNote('');
        }}
        value={note}
        onChange={setNote}
        onAction={() => handleReject()}
        onCancel={() => {
          setOpenModal(false);
          setSelectedId('');
          setNote('');
        }}
        isDataSubmitting={modalBtnLoading}
      />
    </Card>
  );
}

// ----------------------------------------------------------------------

function applySortFilter({ tableData, comparator, filterName, filterClass }) {
  const stabilizedThis = tableData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    tableData = tableData.filter(
      (item) => item.requesterUserId.fullName.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  if (filterClass !== 'all') {
    tableData = tableData.filter((item) => item.classId._id === filterClass);
  }

  return tableData;
}

InviteTable.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  filterOption: PropTypes.arrayOf(PropTypes.object)
};
